import { logParamKey, Route, secretParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'title',
        direction: 'asc',
    })
}

export enum CompanySecretRouteName {
    Index = 'company.secrets.index',
    Create = 'company.secrets.create',
    Edit = 'company.secrets.edit',
    Show = 'company.secrets.show',
    Logs = 'company.secrets.logs',
    LogDetails = 'company.secrets.logs.details',
}

export default {
    path: 'secrets',
    name: CompanySecretRouteName.Index,
    component: () => import('@/views/company/secret/Index.vue'),
    meta: {
        label: 'Company Secrets',
        auth: true,
        permission: Permission.SecretView,
    },
    children: [
        {
            path: 'create',
            name: CompanySecretRouteName.Create,
            component: () => import('@/views/company/secret/Index.vue'),
            meta: {
                label: 'Create Secret',
                auth: true,
                permission: Permission.SecretCreate,
            },
        },
        {
            path: `:${secretParamKey}/edit`,
            name: CompanySecretRouteName.Edit,
            component: () => import('@/views/company/secret/Index.vue'),
            meta: {
                label: 'Edit Secret',
                auth: true,
                permission: Permission.SecretUpdate,
            },
        },
        {
            path: `:${secretParamKey}`,
            name: CompanySecretRouteName.Show,
            component: () => import('@/views/company/secret/Index.vue'),
            meta: {
                label: 'Secret Details',
                auth: true,
                permission: Permission.SecretView,
            },
        },
        {
            path: `:${secretParamKey}/logs`,
            name: CompanySecretRouteName.Logs,
            component: () => import('@/views/company/secret/Index.vue'),
            meta: {
                label: 'Secret Logs',
                auth: true,
                permission: Permission.EventView,
            },
            children: [
                {
                    path: `:${logParamKey}`,
                    name: CompanySecretRouteName.LogDetails,
                    component: () => import('@/views/company/secret/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
    ],
}
